import Axios from '../../../../Assets/Axios/Axios';

import { useToastContext } from '../../../../Context/ToastContext';

import { EMAIL_TEMPLATES } from '../../../../Constant/Enums';

import CodeVerification from '../Components/CodeVerification';

import { SendCode, VerifyCode } from '../../../../Server/Query';

import { useFormContext } from '../FormContext';

import { generateMaskedEmail } from './../../../../Helpers/contactInformationMasker';

const EmailVerification = () => {
  const { showToastMessage } = useToastContext();
  const { inputs, codeRefId } = useFormContext();

  async function handleSubmit(code) {
    // verify otp
    const { data, errors } = await Axios(VerifyCode({ referenceId: codeRefId.email, code }));

    if (errors) {
      showToastMessage('Something went wrong, failed send email otp');
      return { error: true };
    }

    if (data.VerifyCode.status === 'failed')
      return { error: 'Entered OTP is incorrect', shouldDisplayError: true };

    return { error: null };
  }

  async function resendVerificationCode() {
    const response = await Axios(SendCode({ email: inputs.email, template: EMAIL_TEMPLATES.VERIFY_EMAIL }));

    if (response.errors) throw new Error('Something went wrong');

    codeRefId.email = response.data.SendCode.referenceId;
  }

  return (
    <CodeVerification
      handleSubmit={handleSubmit}
      resendVerificationCode={resendVerificationCode}
      helperText="*Check your spam folder as well, if you don't see it in your inbox."
      description={
        <>
          Enter the OTP Number <br />
          Code is sent to {generateMaskedEmail(inputs.email)}
        </>
      }
    />
  );
};

export default EmailVerification;
